<div class="card gateway-detail">
  <iotnet-gateway-caption class="gateway-detail__caption" [gateway]="gateway()" [status]="healthStatus()" />
  <button type="button" class="gateway-detail__close" (click)="close()">
    <svg-icon src="assets/images/icons/x.svg"></svg-icon>
  </button>

  <service-tags [tags]="tags()" [firewallEnabled]="false"></service-tags>

  <div class="service__current gateway-detail__current">
    <div class="service__current-col">
      <div class="service__current-title">{{ "ServiceElement.Chart.NowIn" | translate }}</div>
      @if (currentRates(); as rates) {
        <div>{{ rates.in }}</div>
      } @else {
        <div class="gateway-detail__rate-loader"></div>
      }
    </div>
    <div class="service__current-col">
      <div class="service__current-title">{{ "ServiceElement.Chart.NowOut" | translate }}</div>
      @if (currentRates(); as rates) {
        <div>{{ rates.out }}</div>
      } @else {
        <div class="gateway-detail__rate-loader"></div>
      }
    </div>
  </div>
</div>

<iotnet-gateway-traffic-chart
  class="gateway-detail__chart"
  [customerId]="customerId()"
  [gatewayId]="gateway().gateway_id"
/>
